module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "default",
    staticClass: "default btn",
    on: {
      "click": _vm.defaultt
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('div', {
    ref: "info",
    staticClass: "info btn",
    on: {
      "click": _vm.info
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    ref: "success",
    staticClass: "success btn",
    on: {
      "click": _vm.success
    }
  }, [_vm._v("success")]), _vm._v(" "), _c('div', {
    ref: "warning",
    staticClass: "warning btn",
    on: {
      "click": _vm.warning
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('div', {
    ref: "error",
    staticClass: "error btn",
    on: {
      "click": _vm.error
    }
  }, [_vm._v("error")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4558dedb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = 8
// module chunks = 0